import React, {Component} from 'react';

import I18n from 'app/common/i18n';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';

import AddIcon from 'app/assets/add.svg';
import ColoredCandidateIcon from 'app/assets/candidate-green.svg';
import ColoredEntityIcon from 'app/assets/entity-green.svg';

import {PrimaryStatsCounter, Button} from 'dk-ui-lib';

class PrimaryStatsGroup extends Component {

  render() {
    let {stats} = this.props;
    return (
      <div className='flex justify-around items-center'>
        <PrimaryStatsCounter
          icon={<ColoredCandidateIcon className='svg-icon svg-3x'/>}
          labelLineOne={I18n.t('dashboard.candidates')}
          labelLineTwo={I18n.t('dashboard.registered')}
          count={stats.candidatesCount}
        />
        <div className="border-right grey-border self-stretch"/>
        <PrimaryStatsCounter
          icon={<ColoredEntityIcon className='svg-icon svg-3x'/>}
          labelLineOne={I18n.t('dashboard.entities')}
          labelLineTwo={I18n.t('dashboard.registered')}
          count={stats.entitiesCount}
          // onClick={() => this.handleClick()}
        />
        <div className='col-2'>
          <Button
            type='primary'
            buttonStyle={{padding: '0.75rem'}}
            icon={<AddIcon className='svg-icon'/>}
            labelStyle={{fontSize: '0.9rem'}}
            label={I18n.t('dashboard.add')}
            onClick={() => this.handleAddAcademy()}
          />
        </div>
      </div>
    );
  }

  handleAddAcademy() {
    history.push(routePath.academyOnboardRoute);
  }
}
export default PrimaryStatsGroup;



// WEBPACK FOOTER //
// ./src/views/dashboard/PrimaryStatsGroup.js